import { getTokenAsync } from "../../hooks/API/getAuthToken";
import packageJson from "../../../package.json";

export async function makeServiceHeaders(): Promise<HeadersInit> {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${await getTokenAsync(true)}`,
    "X-Client-Version": packageJson.version,
  };
}
